import React from 'react';

import { Partner } from 'src/reducers/partner/types';

import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';

import { PARTNER_SCOPE_TYPES, PARTNER_TYPES } from 'Constants/partnerTypes';

type Props = {
  partner: Partner;
  scopeDetails?: ScopeDetails;
  scopes: string[];
  scopeType: PARTNER_SCOPE_TYPES;
};

const scopeInfoClick = (scope: string, scopeDetails: ScopeDetails) => {
  mediator.publish('partner:consentInfo', { scope, scopeDetails });
};

const displaySection = (scopeType: PARTNER_SCOPE_TYPES, partner: Partner): boolean => {
  return scopeType === 'read' || partner.type !== 'fhir';
};

const getSharingKey = (partner: Partner, scopeType: PARTNER_SCOPE_TYPES): string => {
  switch (partner.type) {
    case PARTNER_TYPES.COMMERCIAL_API:
      switch (scopeType) {
        case 'read':
          return 'Partners.Commercialapi.youAreSharingScope';
        default:
          return '';
      }

    case PARTNER_TYPES.INBOUND:
      switch (scopeType) {
        case 'write':
          return 'Partners.Inbound.isSharing';
        default:
          return '';
      }

    default:
      switch (scopeType) {
        case 'read':
          return 'PartnersGeneric.youAreSharing';
        case 'write':
          return 'PartnersGeneric.partnerIsSharing';
        default:
          return '';
      }
  }
};

const ScopeSection: React.FC<React.PropsWithChildren<Props>> = ({
  partner,
  scopeDetails,
  scopes,
  scopeType,
}) => {
  if (!scopes.length || !scopeDetails || !displaySection(scopeType, partner)) {
    return null;
  }

  const scopeList = scopes.map((scope, index) => (
    <React.Fragment key={`${scopeType}-${scope}-${partner.type}-${partner.name}`}>
      {index > 0 && <>, </>}
      <button
        id={`partner-${scopeType}-scopes-link`}
        className="btn btn-link align-self-start line-height-xxl p-0"
        onClick={() => scopeInfoClick(scope, scopeDetails)}
      >
        {i18n.t(`Scopes.${scope.replace(/\./g, '_')}ScopeName`)}
      </button>
    </React.Fragment>
  ));

  return (
    <>
      <div id={`${scopeType}-info`} className="pt-3">
        <span id={`partner-${scopeType}-sharing-text`} className="mb-3 text-semiBold d-block">
          {i18n.t(getSharingKey(partner, scopeType), {
            partner: partner.name,
            partnerName: partner.name,
          })}
        </span>
        <span id={`${scopeType}-permissions-text`} className="mb-3 d-block">
          {scopeList}
        </span>
      </div>
    </>
  );
};

export default ScopeSection;
